import { render } from "./securityoverride.vue?vue&type=template&id=5fb9f131"
import script from "./securityoverride.vue?vue&type=script&lang=js"
export * from "./securityoverride.vue?vue&type=script&lang=js"

import "./securityoverride.vue?vue&type=style&index=0&id=5fb9f131&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__